module.exports = __webpack_public_path__ + "static/Miniens1-913f8f985b20c7162a43e01f3beffb56.png";